/* @flow */
import {
  JOIN_COMMUNITY_CHAT_CHANNEL,
  CLOSE_CHAT_MODAL,
  LAUNCH_COMMUNITY_CHAT,
} from './action-types.js';

// Slack Community Chat Actions
export const requestToJoinCommunityChat = (resendEmail?: boolean) => ({
  type: JOIN_COMMUNITY_CHAT_CHANNEL,
  payload: resendEmail,
});

export const resetChatModal = () => ({
  type: CLOSE_CHAT_MODAL,
});

export const launchCommunityChat = () => ({
  type: LAUNCH_COMMUNITY_CHAT,
});



// WEBPACK FOOTER //
// ./src/app/modules/chat/actions.js